import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function History({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 12 12' {...props}>
      <Path
        d='M1 7.68796H3.78537'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.78548 9.35422H2.11426'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.78657 11.0278H3.22949'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.85645 3.77734V6.36829L7.89311 7.61001'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.03223 5.45659C1.30965 2.95031 3.43265 1 6.01302 1C8.78223 1 11.0267 3.24445
         11.0267 6.01366C11.0267 8.78287 8.78223 11.0273 6.01302 11.0273'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

History.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default History
